module.exports = __webpack_public_path__ + "static/media/x-circle.4fe49932.svg";